import router from '@/router';
import store from '@/store';

const utils = {
  getBreakpointsMap() {
    let mapString = getComputedStyle(document.head).getPropertyValue('font-family');
    mapString = mapString.replace('/map-to-JSON((', '');
    mapString = mapString.replace('))/', '');
    const mapArray = mapString.split(',');
    const map = new Map();
    mapArray.forEach((b) => {
      const s = b.split(':');
      map.set(s[0].replace(/["]/gi, '').trim(), parseInt(s[1].replace('px', ''), 10));
    });
    return map;
  },

  screenIsUntil(breakpoint) {
    const map = utils.getBreakpointsMap();
    return window.innerWidth < map.get(breakpoint);
  },

  isTouchDevice() {
    return window.matchMedia('(pointer: coarse) and (hover: none)').matches;
  },

  isSafari() {
    const ua = navigator.userAgent.toLowerCase();
    let isSafari = false;
    isSafari = /constructor/i.test(window.HTMLElement) ||
              (p => p.toString() === '[object SafariRemoteNotification]')(!window.safari || window.safari.pushNotification);
    isSafari = (
      isSafari ||
      ((ua.indexOf('safari') !== -1) &&
      (!(ua.indexOf('chrome') !== -1) &&
      (ua.indexOf('version/') !== -1)))
    );
    return isSafari;
  },

  isInRect(mouse, rect) {
    return (
      mouse.x > rect.left &&
      mouse.y > rect.top &&
      mouse.x < rect.right &&
      mouse.y < rect.bottom
    );
  },

  checkRoute(active) {
    let current = active;
    // const data = router.name === 'project' ? store.state.firebase.investimenti.childrens : router.name === 'person' ? store.state.firebase.team.childrens : store.state.firebase;
    const data = router.name !== 'project' ? store.state.firebase : store.state.firebase.investimenti.childrens;
    const pathLang = store.state.lang === 'it' ? 'path' : 'pathEn';

    Object.keys(data).forEach((key) => {
      if (data[key][pathLang].substr(1) === active) current = key;
    });

    return current;
  },
};

export default utils;
